import { render, staticRenderFns } from "./Fixed_Assets.vue?vue&type=template&id=55a2cee2&scoped=true&"
import script from "./Fixed_Assets.vue?vue&type=script&lang=js&"
export * from "./Fixed_Assets.vue?vue&type=script&lang=js&"
import style0 from "./Fixed_Assets.vue?vue&type=style&index=0&id=55a2cee2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a2cee2",
  null
  
)

export default component.exports